import React from 'react'

import { Loader2 } from 'lucide-react'

import SearchProgressBar from '@src/pages/Exchange/components/SelectTokenModal/components/SearchProgressBar'

interface SearchingIndicatorProps {
    searchProgress: {
        completed: number
        total: number
    }
}

export const SearchingIndicator: React.FC<SearchingIndicatorProps> = ({ searchProgress }) => (
    <div className='flex flex-col items-center justify-center gap-4 p-8'>
        <div className='flex items-center gap-2'>
            <Loader2 className='h-5 w-5 animate-spin' />
            <span>Searching all blockchains...</span>
        </div>
        <SearchProgressBar completed={searchProgress.completed} total={searchProgress.total} />
    </div>
)

export default SearchingIndicator
